export default "__VITE_ASSET__DyrVJTCC__"